<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2bm"><a id="contents"></a><a id="page_vi"></a><a id="page_vii">CONTENTS</a></h2><a id="page_vii">
</a><p class="tocb"><a id="page_vii"></a><a href="#/xhtml/intro">Introduction: Jefferson’s Quran</a></p>
<p class="toc-part"><a href="#/xhtml/part01">PART ONE: Islam 101</a></p>
<p class="toc"><a href="#/xhtml/ch01">1: Islam and End Times</a></p>
<p class="toc"><a href="#/xhtml/ch02">2: From Revelation to Empire</a></p>
<p class="toc"><span href="#/xhtml/ch03" title="Link target outside of Sample">3: Wahhabism and Salafism</span></p>
<p class="tocb"><span href="#/xhtml/ch04" title="Link target outside of Sample">4: Reestablishing the Caliphate</span></p>
<p class="toc-part"><span href="#/xhtml/part02" title="Link target outside of Sample">PART TWO: Thirteen Deadly Lies</span></p>
<p class="toc"><span href="#/xhtml/part02_intro" title="Link target outside of Sample">Introduction to Part Two</span></p>
<p class="toc"><span href="#/xhtml/ch05" title="Link target outside of Sample">Lie #1: “Islam is a religion of peace, and Islamic terrorists aren’t really Muslims.”</span></p>
<p class="toc"><span href="#/xhtml/ch06" title="Link target outside of Sample">Lie #2: “Islam is not much different than Christianity or Judaism.”</span></p>
<p class="toc"><span href="#/xhtml/ch07" title="Link target outside of Sample">Lie #3: “Jihad is a peaceful, internal struggle, not a war against infidels.”</span></p>
<p class="toc"><span href="#/xhtml/ch08" title="Link target outside of Sample">Lie #4: “Muslims don’t actually seek to live under sharia, let alone impose it on others; there are so many different interpretations of it anyway.”</span></p>
<p class="toc"><span href="#/xhtml/ch09" title="Link target outside of Sample">Lie #5: “America is safe from sharia law.”</span></p>
<p class="toc"><a id="page_viii"></a><span href="#/xhtml/ch10" title="Link target outside of Sample">Lie #6: “The Caliphate is a fanciful dream.”</span></p>
<p class="toc"><span href="#/xhtml/ch11" title="Link target outside of Sample">Lie #7: “Islam is tolerant toward non-Muslims.”</span></p>
<p class="toc"><span href="#/xhtml/ch12" title="Link target outside of Sample">Lie #8: “Addressing frustration, poverty, and joblessness in the Muslim world—maybe even climate change—will end terrorism.”</span></p>
<p class="toc"><span href="#/xhtml/ch13" title="Link target outside of Sample">Lie #9: “Critics of Islam are bigots.”</span></p>
<p class="toc"><span href="#/xhtml/ch14" title="Link target outside of Sample">Lie #10: “Islam respects the rights of women.”</span></p>
<p class="toc"><span href="#/xhtml/ch15" title="Link target outside of Sample">Lie #11: “Iran can be trusted with a nuclear weapon.”</span></p>
<p class="toc"><span href="#/xhtml/ch16" title="Link target outside of Sample">Lie #12: “The Muslim Brotherhood is a moderate, mainstream Islamic group.”</span></p>
<p class="tocb"><span href="#/xhtml/ch17" title="Link target outside of Sample">Lie #13: “Islam respects freedom of speech.”</span></p>
<p class="toc-part"><span href="#/xhtml/part03" title="Link target outside of Sample">PART THREE: What Can Be Done</span></p>
<p class="toc"><span href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/authorbio" title="Link target outside of Sample">About Glenn Beck</span></p>
<p class="toc1"><span href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?02223e9c